import { z } from "zod";
import { paginateSchema } from "./pagination.validator";
import { createdAttendance } from "./attendances.validator";
import { IdType } from "./base.validator";
import { createdProfile } from "./profile.validators";

export const dayLogEntry = createdAttendance.omit({ userId: true, day: true });

export const dayLog = z.object({
	day: z.string().datetime(),
	totalMillis: z.number(),
	entries: dayLogEntry.array(),
});

export const groupedUserDayAttendance = z.object({
	userId: IdType,
	dayLogs: dayLog.array(),
	totalMillis: z.number(),
});

export enum DaylogStatus {
	present = "present",
	onLeave = "onLeave",
	pending = "pending",
}
export const dayLogWithStatus = dayLog.extend({
	status: z.nativeEnum(DaylogStatus),
});

export type DayLogWithStatus = z.infer<typeof dayLogWithStatus>;

export const groupedUserDayAttendanceStatus = groupedUserDayAttendance.extend({
	dayLogs: dayLogWithStatus.array(),
});
export type GroupedUserDayAttendanceWithStatus = z.infer<
	typeof groupedUserDayAttendanceStatus
>;

export type DayLog = z.infer<typeof dayLog>;

export const dayAttendanceDetails = z.object({
	day: z.string().datetime(),
	present: z.number().int(),
	onLeave: z.number().int(),
	pending: z.number().int(),
	totalEmployees: z.number().int(),
});
export type DayAttendanceDetails = z.infer<typeof dayAttendanceDetails>;

export const findAllAttendanceFilter = createdAttendance
	.pick({
		id: true,
	})
	.extend({
		startDate: z.string().datetime(),
		endDate: z.string().datetime(),
	})
	.partial();

export type FindAllAttendanceFilterDto = z.infer<
	typeof findAllAttendanceFilter
>;

export const paginatedGroupedDayAttendance = paginateSchema(
	groupedUserDayAttendance
).extend({
	days: dayAttendanceDetails.array(),
	profiles: createdProfile
		.pick({
			id: true,
			firstName: true,
			lastName: true,
			department: true,
			profilePicture: true,
		})
		.array(),
});

export type PaginatedGroupedDayAttendace = z.infer<
	typeof paginatedGroupedDayAttendance
>;
